<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>CONTENTS</b></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">1. My Detroit</a></p>
<p class="toc1"><span href="#/chapter02" title="Link target outside of Sample">2. “Forget All Your Troubles, Forget All Your Cares…”</span></p>
<p class="toc1"><span href="#/chapter03" title="Link target outside of Sample">3. Pardridge in a Pear Tree</span></p>
<p class="toc1"><span href="#/chapter04" title="Link target outside of Sample">4. The Heart of Detroit</span></p>
<p class="toc1"><span href="#/chapter05" title="Link target outside of Sample">5. Rescue Mission</span></p>
<p class="toc1"><span href="#/chapter06" title="Link target outside of Sample">6. Family Plot</span></p>
<p class="toc1"><span href="#/chapter07" title="Link target outside of Sample">7. The Friendly Store</span></p>
<p class="toc1"><span href="#/chapter08" title="Link target outside of Sample">8. A Great Place to Shop</span></p>
<p class="toc1"><span href="#/chapter09" title="Link target outside of Sample">9. (A Hunk’a) Burnin’ Love</span></p>
<p class="toc1"><span href="#/chapter10" title="Link target outside of Sample">10. Detroit’s Own Department Store</span></p>
<p class="tocat"><span href="#/appendixa" title="Link target outside of Sample">Appendix A. Crowley’s Downtown Store Directory</span></p>
<p class="toca"><span href="#/appendixb" title="Link target outside of Sample">Appendix B. Crowley’s Store Locations</span></p>
<p class="toca"><span href="#/appendixc" title="Link target outside of Sample">Appendix C. Crowley Family Tree</span></p>
<p class="toca"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toca"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7c2f8604